// extracted by mini-css-extract-plugin
export var levelH2 = "post-module--levelH2--d4676";
export var levelH3 = "post-module--levelH3--27f1a";
export var levelH4 = "post-module--levelH4--88692";
export var postMeta = "post-module--postMeta--c4591";
export var postMetaItem = "post-module--postMetaItem--615f8";
export var postMetaTag = "post-module--postMetaTag--d05ee";
export var postMetaTags = "post-module--postMetaTags--04bb6";
export var toc = "post-module--toc--3f8e2";